// components/PremiumOverlayCard.jsx
import React, { useState } from "react";
import UpgradePremiumModal from "../pages/Layout/DashboardLayout/BillingDashboard/modals/UpgradePremiumModal";

const PremiumOverlayCard = ({ children, showOverlay }) => {
  const [activeModal, setActiveModal] = useState(null)
  const openModal = ()=>{
    setActiveModal(true);
  }
  const closeModal = ()=>{
    setActiveModal(false);
  }
  return (
    <div className="position-relative">
      {/* Always render children */}
      <div className={showOverlay ? "blurred-content" : ""}>
        {children}
      </div>

      {showOverlay && (
        <>
        {activeModal && (<UpgradePremiumModal show={activeModal} openModal={openModal} onClose={closeModal}/>)}
        <div className="overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center">
          <div className="premium-badge" onClick={() => openModal("upgrade")}><i className="bi bi-lock-fill me-1"></i> Upgrade</div>
        </div>
        </>
      )}
    </div>
  );
};

export default PremiumOverlayCard;
